
  export default {
    name: 'EconRevTemplate',
  };
